import script from "./NotificationPopover.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationPopover.vue?vue&type=script&setup=true&lang=js"

import "./NotificationPopover.vue?vue&type=style&index=0&id=2d334542&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d334542"]])

export default __exports__